import React, { useState } from 'react';
import {
  Alert,
  AlertIcon,
  Button,
  ButtonGroup,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Divider,
  FormControl,
  FormHelperText,
  FormLabel,
  Heading,
  Input,
  Stack,
  useColorModeValue,
} from '@chakra-ui/react';
import { getBackendURL, getBackendURLWithSuffix, setAndClear, apiFetch } from '../../../utils/utils';

function PlanForm({ onPlanAdded }) {
  const [planName, setPlanName] = useState('');
  const [planPrice, setPlanPrice] = useState('');
  const [autoSMSProfiles, setAutoSMSProfiles] = useState(0);
  const [digiCardProfiles, setDigiCardProfiles] = useState(0);

  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [inProgress, setInProgress] = useState(false);

  const onSubmit = () => {
    setError('');
    if (planName === '' || planPrice === '' || digiCardProfiles === 0) {
      setError('Please set the proper details');
      return;
    }
    setInProgress(true);
    apiFetch(`${getBackendURL()}/admin/distributor/plans/add`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        name: planName,
        price: planPrice,
        autoSMSProfiles,
        digiCardProfiles,
      }),
    })
      .then(response => response.json())
      .then(response => {
        setPlanName('');
        setPlanPrice('');
        setAutoSMSProfiles(false);
        setDigiCardProfiles(false);
        setInProgress(false);
        if (response.plan) {
          setAndClear(response.message, setSuccess);
          onPlanAdded();
        } else {
          setAndClear(response.message, setError);
        }
      })
      .catch(error => {
        setInProgress(false);
        setAndClear(error, setError);
      });
  };

  return (
    <Card
      bg={useColorModeValue('white', 'gray.700')}
      data-testid="add-plan-form-card"
    >
      <CardHeader>
        <Heading size="md" data-testid="add-plan-form-heading">
          {'Add Plan'}
        </Heading>
      </CardHeader>
      <Divider />
      <CardBody>
        <Alert status="success" display={success ? 'flex' : 'none'}>
          <AlertIcon />
          {success}
        </Alert>
        <Alert status="error" display={error ? 'flex' : 'none'}>
          <AlertIcon />
          {error}
        </Alert>
        <Stack spacing="4" mt="2">
          <FormControl>
            <FormLabel>Plan Name</FormLabel>
            <Input
              type="text"
              id="plan-name"
              value={planName}
              name="plan-name"
              onChange={event => setPlanName(event.target.value)}
            />
          </FormControl>
          <FormControl>
            <FormLabel>Plan Price</FormLabel>
            <Input
              id="plan-price"
              name="plan-price"
              value={planPrice}
              onChange={event => setPlanPrice(event.target.value)}
            />
            <FormHelperText>Price of the plan</FormHelperText>
          </FormControl>
          {/* // TODO: Enable Auto SMS Support */}
          {/* <FormControl>
            <FormLabel>Profiles for Auto SMS</FormLabel>
            <Input type='number' value={autoSMSProfiles}
                   onChange={(event) => setAutoSMSProfiles(event.target.value)} />
            <FormHelperText>
              Number of profiles allowed for Auto SMS product
            </FormHelperText>
          </FormControl> */}
          <FormControl>
            <FormLabel>Profiles for Digi Card</FormLabel>
            <Input
              type="number"
              value={digiCardProfiles}
              onChange={event => setDigiCardProfiles(event.target.value)}
            />
            <FormHelperText>
              Number of profiles allowed for Digi Card product
            </FormHelperText>
          </FormControl>
        </Stack>
      </CardBody>
      <Divider />
      <CardFooter>
        <ButtonGroup spacing="2">
          <Button
            variant="solid"
            colorScheme="teal"
            onClick={onSubmit}
            isLoading={inProgress}
            loadingText="Submitting..."
            data-testid="add-plan-submit-button"
          >
            Add Plan
          </Button>
        </ButtonGroup>
      </CardFooter>
    </Card>
  );
}

export default PlanForm;
